<template>
  <div>
    <template v-for="(template, index) in group.templates">
      <TemplateItem 
              :key="index+'-'+template.id"
              :template="template"
              :isPrivate="group.personal"
              @template-message-edit="handleMessageEdit"
              @template-message-delete="handleMessageDelete"
              @template-send-as-sms="handleSendAsSMS"/>
    </template>
  </div>
</template>

<script>

import TemplateItem from './TemplateItem'

export default {
  name: 'TemplateList',
  components: {
    TemplateItem
  },
  props: {
    group: {
      type: Object,
      required: true,
      default: () => null
    }
  },
  computed: {
  },
  methods: {
    contactSelection: function(e, flag) {
      this.$emit('birthday-group-contact-selection', e, flag)
    }, 
    handleContactToggle: function(contactId) {
      this.$emit('birthday-group-contact-toggle', contactId)
    },
    handleMessageEdit: function(message) {
      this.$emit('template-message-edit', message)
    }, 
    handleMessageDelete: function(id) {
      this.$emit('template-message-delete', id)
    },
    handleSendAsSMS: function(content) {
      this.$emit('template-send-as-sms', content)
    },
  }
}

</script>

<style scoped lang="css">

  .scroll-area {
    position: relative;
    height: calc(100vh - 40.4vh);
  }

  .tab-content {
    border: 0 !important;
  }

  .sk-circle{
    margin: 0 auto 1px auto;
    width: 20px;
    height: 20px;
    position: relative;
    color: white !important;
  }

</style>